module.exports = __webpack_public_path__ + "static/03-562da7f6ca50b26225224631247d8128.jpg";